import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface StoreCurrency {
  code: string;
  symbol: string;
  position: 'before' | 'after';
  rate?: number;
}

export const useStoreCurrency = () => {
  const [currency, setCurrency] = useState<StoreCurrency>({
    code: 'RSD',
    symbol: 'RSD',
    position: 'after',
    rate: 1
  });

  useEffect(() => {
    fetchStoreCurrency();
  }, []);

  const fetchStoreCurrency = async () => {
    try {
      // limit(1) jer bez tenant konteksta (apex domen, super_admin) RLS pusti
      // po jedan red za svaki tenant, a maybeSingle() na 4 reda vrati PGRST116.
      const { data: paymentData, error: paymentError } = await supabase
        .from('payment_settings')
        .select('currency')
        .limit(1)
        .maybeSingle();

      if (paymentError) {
        console.error('Error fetching payment settings:', paymentError);
        return;
      }

      if (paymentData?.currency) {
        const { data: currencyData, error: currencyError } = await supabase
          .from('currencies')
          .select('*')
          .eq('code', paymentData.currency)
          .maybeSingle();

        if (currencyError) {
          console.error('Error fetching currency details:', currencyError);
          setCurrency({
            code: paymentData.currency,
            symbol: paymentData.currency,
            position: 'after',
            rate: 1
          });
          return;
        }

        if (currencyData) {
          console.log('Using currency data with rate:', currencyData);
          setCurrency({
            code: currencyData.code,
            symbol: currencyData.symbol || currencyData.code,
            position: 'after',
            rate: currencyData.rate || 1
          });
        } else {
          setCurrency({
            code: paymentData.currency,
            symbol: paymentData.currency,
            position: 'after',
            rate: 1
          });
        }
      }
    } catch (error) {
      console.error('Error in fetchStoreCurrency:', error);
    }
  };

  const formatPrice = (price: number) => {
    const convertedPrice = currency.rate && currency.rate !== 1 
      ? price * currency.rate 
      : price;
    
    const formattedNumber = convertedPrice.toFixed(2);
    return currency.position === 'before' 
      ? `${currency.symbol} ${formattedNumber}`
      : `${formattedNumber} ${currency.symbol}`;
  };

  return { currency, formatPrice };
}; 